<!--<style lang="scss" scoped>  @import "../styles/labels.scss"; </style>-->
<template>
  <div id="labels" class="pb-10 mb-10">
    <v-dialog
      v-model="showDatePicker"
      ref="dialog"
      width="290px"
      persistent
    >
      <v-date-picker
        v-model="datePickerDate"
        :range="isAdmin"
        no-title
        @close="!isAdmin && closeDatePicker()"
        @change="closeDatePicker"
      ></v-date-picker>
      <v-btn v-if="isAdmin" @click="closeDatePicker">Close</v-btn>
    </v-dialog>
    <v-toolbar flat class="d-print-none">
      <ProductionSelector
        :dates="dates"
        :production="production"
        v-on:update:dates="dates=$event"
        v-on:update:production="production=$event"
      />

      <template v-if="!basicView">
        <v-spacer/>
        <v-text-field
          v-model="searchEmail"
          label="Search by emails (separate with comma, can be partial)"
          clearable
        />
        <v-spacer/>
        <v-text-field
          v-model="searchName"
          label="Search by name  (separate with comma, can be partial)"
          clearable
        />
      </template>

      <template v-if="basicView">
        <v-spacer/>
        <v-btn text :to="{name:'LabelSearch'}" class="mr-2">Label Search</v-btn>
        <v-checkbox
          label="Force Sticker"
          v-model="forceSticker"
        />
      </template>

    </v-toolbar>
    <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
    <v-container class="dontPrint" v-if="!loading && !basicView">
      <v-row wrap row>
        <v-col class="text-xs-center py-2">
          <v-chip v-if="!loading">{{ orders.length }} of {{ allOrders.length }} labels</v-chip>
          {{ showAll ? `excluding ${extraOrders.length} extras/snacks` : '' }}
        </v-col>
        <v-col>
          <v-select
            label="Paginate"
            v-model="pageSize"
            :items="[null,250,500,1000]"
            clearable
          />
          <v-btn-toggle v-model="selectPage">
            <v-btn v-for="page of pages" v-bind:key="page">{{ page }}</v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col>
          <v-btn-toggle v-model="show">
            <v-btn value="all">All</v-btn>
            <v-btn value="filter">Apply Filter</v-btn>
            <v-btn value="meals">By Meal</v-btn>
          </v-btn-toggle>
          <v-select
            label="Exclude Tags"
            v-model="excludeTags"
            multiple
            :items="customerTags"
            clearable
          />
        </v-col>
      </v-row>
      <template v-if="showFilter">
        <v-row wrap row>
          <v-col class="text-xs-center py-2">
            <v-btn-toggle v-model="streamSelection" multiple>
              <v-btn v-for="(stream,index) in activeStreams" v-bind:key="index" text
                     :value="stream.id">
                {{ stream.name }}
              </v-btn>
              <v-btn text :value="'chefs_choice'">
                chefs choice
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row wrap row align="center">
          <v-col cols="3" class="text-xs-center py-2">
            <v-btn-toggle v-model="sizeSelection" multiple>
              <v-btn
                v-for="size in ['small', 'medium', 'large']"
                v-bind:key="size" text :value="size">
                {{ size }}
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col cols="3" class="text-xs-center py-2">
            <v-btn-toggle v-model="dateSelection" multiple>
              <v-btn
                v-for="date in dates"
                v-bind:key="date" text :value="date">
                {{ formatDate(date, {formatString: 'ddd'}) }}
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col cols="6" class="text-xs-center py-2">
            <v-btn-toggle v-model="restrictionFilter" multiple>
              <v-btn value="no-allergy">No Allergy</v-btn>
              <v-btn value="active-allergy">Active Allergy</v-btn>
              <v-btn value="no-active-allergy">Inactive Allergy</v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row wrap row align="center">
          <v-col class="text-xs-center py-2">
            <v-btn-toggle dense v-model="todSelection" multiple>
              <v-btn small text :value="tod" v-for="tod in tods" v-bind:key="tod">
                {{ tod }}
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row wrap row align="center">
          <v-col class="text-xs-center py-2">
            <v-btn-toggle dense v-model="containerSizeSelection" multiple>
              <v-btn small text :value="size" v-for="size in containerSizes" v-bind:key="size">
                Container: {{ size }}
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </template>
      <v-row align-center wrap row v-if="mealsNotFound" class="dontPrint">
        <v-spacer/>
        <v-col xs4 class="text-xs-center mx-5 py-2">
          <div v-for="(count,mealId) in mealsNotFound" v-bind:key="mealId">
            <v-alert type="warning"
                     :value="!!mealsNotFound[mealId]"
                     light
            >
              meal {{ mealId }} was not found (quantity ordered {{ count }})
            </v-alert>
          </div>
        </v-col>
        <v-spacer/>
      </v-row>
    </v-container>
    <v-container flat class="pa-4 dontPrint" v-if="hasMissingBinAssignment">
      <v-alert outlined text type="warning">
        <template v-if="missingBinAssignments.length>10">
          {{ missingBinAssignments.length }} orders are missing a bin assignment
        </template>
        <template v-else>
          {{ missingBinAssignments.length }} orders are missing a bin assignment:
          <ul>
            <li v-for="(o,i) of missingBinAssignments.sort((a,b)=>a.first_name.localeCompare(b.first_name))"
                v-bind:key="i">
              <v-chip class="mx-1" small outlined>Shipping: {{ o.shipping_group }}</v-chip>
              <v-chip class="mx-1" small outlined>Production: {{ o.production }}</v-chip>
              {{ [o.first_name, o.last_name].join(' ') }} : {{ o.meal.name }}
            </li>
          </ul>
        </template>
        <v-btn text outlined class="ml-6" :to="{ name: 'Packing', query: { dates: dates, production }}">Go to Packing
          Page
        </v-btn>

      </v-alert>
    </v-container>
    <template v-if="showMeals">
      <v-container fluid>
        <v-alert type="warning" v-if="hasMissingBinAssignment">
          Printing is disabled until bins have been assigned.
        </v-alert>

        <!-- Progress Indicators -->
        <v-card class="mb-4" outlined>
          <v-card-text>
            <v-row>
              <v-col cols="6" v-if="hasSleeveMeals">
                <div class="text-subtitle-1 mb-2">Sleeve - Individual Labels</div>
                <v-progress-linear
                  :value="sleeveProgress"
                  :color="sleeveProgress === 100 ? 'success' : 'primary'"
                  height="25"
                  class="mb-3"
                >
                  <template v-slot:default>
                    <strong>{{ sleevePrinted }} / {{ sleeveTotal }} labels printed</strong>
                  </template>
                </v-progress-linear>
                <div class="text-caption mb-2">Label Types (Unique meal/size combinations)</div>
                <v-progress-linear
                  :value="sleeveLabelTypesProgress"
                  :color="sleeveLabelTypesProgress === 100 ? 'success' : 'info'"
                  height="20"
                >
                  <template v-slot:default>
                    <small>{{ sleeveLabelTypesPrinted }} / {{ sleeveLabelTypesTotal }} types</small>
                  </template>
                </v-progress-linear>
              </v-col>
              <v-col cols="6" v-if="hasStickerMeals">
                <div class="text-subtitle-1 mb-2">Sticker - Individual Labels</div>
                <v-progress-linear
                  :value="stickerProgress"
                  :color="stickerProgress === 100 ? 'success' : 'primary'"
                  height="25"
                  class="mb-3"
                >
                  <template v-slot:default>
                    <strong>{{ stickerPrinted }} / {{ stickerTotal }} labels printed</strong>
                  </template>
                </v-progress-linear>
                <div class="text-caption mb-2">Label Types (Unique meal/size combinations)</div>
                <v-progress-linear
                  :value="stickerLabelTypesProgress"
                  :color="stickerLabelTypesProgress === 100 ? 'success' : 'info'"
                  height="20"
                >
                  <template v-slot:default>
                    <small>{{ stickerLabelTypesPrinted }} / {{ stickerLabelTypesTotal }} types</small>
                  </template>
                </v-progress-linear>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-toolbar flat class="mb-8">
          <v-tabs v-model="mealFilter">
            <v-tab v-if="hasSleeveMeals" tab-value="sleeve">Sleeve</v-tab>
            <v-tab v-if="hasStickerMeals" tab-value="sticker">Sticker</v-tab>
            <v-tab v-if="hasNoneMeals" tab-value="none">None</v-tab>
          </v-tabs>
          <v-spacer/>
          <v-btn :color="selectMany?'success':'primary'"
                 :outlined="!selectMany"
                 :disabled="hasMissingBinAssignment"
                 @click="selectMany=!selectMany">
            Select Many
          </v-btn>
          <v-spacer/>
        </v-toolbar>

        <v-alert v-if="hasStickerMeals && mealFilter === 'sticker'" type="info" text outlined dense class="mb-4">
          These meals have print_option set to 'sticker'
        </v-alert>

        <v-alert v-if="hasSleeveMeals && mealFilter === 'sleeve'" type="info" text outlined dense class="mb-4">
          These meals have print_option set to 'sleeve' or print option is empty.
        </v-alert>

        <v-alert v-if="hasNoneMeals && mealFilter === 'none'" type="info" text outlined dense class="mb-4">
          These meals have print_option set to 'none'
        </v-alert>

        <v-app-bar
          v-if="selectMany"
          fixed
          bottom
          color="success"
        >
          <v-btn outlined @click="selectAll">
            Select All
          </v-btn>
          <v-btn outlined @click="deselectAll" class="ml-2">
            Deselect All
          </v-btn>
          <v-spacer/>
          <v-btn :loading="downloadingMany" :disabled="selectedCount===0" @click="multiselectDownload">
            Download Selected {{ selectedCount }}
          </v-btn>
          <v-spacer/>
          <v-btn @click="selectMany=false">
            Cancel
          </v-btn>
        </v-app-bar>
        <v-row dense wrap row v-for="(meal,i) of meals" v-bind:key="i">
          <v-col>
            <v-chip outlined :color="getDietColor(meal.diet)">{{ getDiet(meal.diet).name }}</v-chip>
            {{ meal.name }}
            <v-chip outlined v-if="meal.diet!==23">
              <!-- show for non-cc meals -->
              {{ formatDate(meal.date, {formatString: 'dddd'}) }}-{{ todMapToString(meal.tod) }}
            </v-chip>
          </v-col>
          <v-col v-if="selectMany">
            <v-toolbar flat dense>
              <v-btn
                v-if="hasMulitpleButtonsForMeal(meal.id) && !hasAnyAlreadyClicked(meal.id)"
                small
                text
                outlined
                class="mr-2"
                :disabled="hasMissingBinAssignment || mealFilter==='none'"
                @click="selectAllForMeal(meal.id)"
              >
                Select All
              </v-btn>
              <v-btn
                v-if="hasAnyAlreadyClicked(meal.id)"
                small
                text
                outlined
                class="mr-2"
                color="warning"
                @click="overrideForMeal(meal.id)"
              >
                Override
              </v-btn>
              <v-checkbox
                hide-details
                class="pa-1 mr-5 label-btn elevation-1"
                :color="isAlreadyClicked[getKey(meal.id,{mealSize:'small'})] ? 'red' : 'primary'"
                :disabled="hasMissingBinAssignment || mealFilter==='none' || (isAlreadyClicked[getKey(meal.id,{mealSize:'small'})] && !overrideMeals[meal.id])"
                v-if="getCountBySize(meal.id, 'small')>0"
                :loading="downloading[`${meal.id}-small`]"
                :label="`S ${getCountBySize(meal.id, 'small')}`"
                v-model="multiselect[`${meal.id}-small`]"
              >
              </v-checkbox>
              <v-checkbox
                hide-details
                class="pa-1 mr-5 label-btn elevation-1"
                :color="isAlreadyClicked[getKey(meal.id,{mealSize:'medium'})] ? 'red' : 'primary'"
                :disabled="hasMissingBinAssignment|| mealFilter==='none' || (isAlreadyClicked[getKey(meal.id,{mealSize:'medium'})] && !overrideMeals[meal.id])"
                v-if="getCountBySize(meal.id, 'medium')>0"
                :loading="downloading[`${meal.id}-medium`]"
                :label="`M ${ getCountBySize(meal.id, 'medium') }`"
                v-model="multiselect[`${meal.id}-medium`]"
              />
              <v-checkbox
                hide-details
                class="pa-1 mr-5 label-btn elevation-1"
                :color="isAlreadyClicked[getKey(meal.id,{mealSize:'large'})] ? 'red' : 'primary'"
                :disabled="hasMissingBinAssignment|| mealFilter==='none' || (isAlreadyClicked[getKey(meal.id,{mealSize:'large'})] && !overrideMeals[meal.id])"
                v-if="getCountBySize(meal.id, 'large')>0"
                :loading="downloading[`${meal.id}-large`]"
                :label="`L ${ getCountBySize(meal.id, 'large') }`"
                v-model="multiselect[`${meal.id}-large`]"
              />
              <v-checkbox
                hide-details
                class="pa-1 mr-5 label-btn elevation-1"
                :color="isAlreadyClicked[getKey(meal.id,{restricted:true})] ? 'red' : 'primary'"
                :disabled="hasMissingBinAssignment|| mealFilter==='none' || (isAlreadyClicked[getKey(meal.id,{restricted:true})] && !overrideMeals[meal.id])"
                v-if="getCountByRestrictions(meal.id)>0"
                :loading="downloading[`${meal.id}-restricted`]"
                :label="`R ${ getCountByRestrictions(meal.id) }`"
                v-model="multiselect[`${meal.id}-restricted`]"
              />
            </v-toolbar>
          </v-col>
          <v-col v-if="!selectMany">
            <v-btn class="mr-5 label-btn"
                   :color="isAlreadyClicked[getKey(meal.id,{mealSize:'small'})] ? 'success' : 'primary'"
                   :disabled="hasMissingBinAssignment || mealFilter==='none'"
                   v-if="getCountBySize(meal.id, 'small')>0"
                   :loading="downloading[`${meal.id}-small`]"
                   @click="selectDownloadDisable(meal.id,{mealSize:'small'},$event)">
              S
              {{ getCountBySize(meal.id, 'small') }}
            </v-btn>
            <v-btn class="mr-5 label-btn"
                   :color="isAlreadyClicked[getKey(meal.id,{mealSize:'medium'})] ? 'success' : 'primary'"
                   :disabled="hasMissingBinAssignment || mealFilter==='none'"
                   v-if="getCountBySize(meal.id, 'medium')>0"
                   :loading="downloading[`${meal.id}-medium`]"
                   @click="selectDownloadDisable(meal.id,{mealSize:'medium'},$event)">
              M
              {{ getCountBySize(meal.id, 'medium') }}
            </v-btn>
            <v-btn class="mr-5 label-btn"
                   :color="isAlreadyClicked[getKey(meal.id,{mealSize:'large'})] ? 'success' : 'primary'"
                   :disabled="hasMissingBinAssignment|| mealFilter==='none'"
                   v-if="getCountBySize(meal.id, 'large')>0"
                   :loading="downloading[`${meal.id}-large`]"
                   @click="selectDownloadDisable(meal.id,{mealSize:'large'},$event)">
              L
              {{ getCountBySize(meal.id, 'large') }}
            </v-btn>
            <v-btn class="label-btn"
                   :color="isAlreadyClicked[getKey(meal.id,{restricted:true})] ? 'success' : 'primary'"
                   :disabled="hasMissingBinAssignment|| mealFilter==='none'"
                   v-if="getCountByRestrictions(meal.id)>0"
                   :loading="downloading[`${meal.id}-restricted`]"
                   @click="selectDownloadDisable(meal.id,{restricted:true},$event)">
              R
              {{ getCountByRestrictions(meal.id) }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-if="!loading && !showMeals">
      <v-toolbar class="d-print-none" flat>
        <v-spacer/>
        <v-btn-toggle v-model="labelFormat">
          <v-btn value="large">Sticker</v-btn>
          <v-btn value="direct">Sleeve</v-btn>
        </v-btn-toggle>
        <v-spacer/>
      </v-toolbar>

      <template v-if="labelFormat==='large'">
        <div style="font-family: 'Gotham Light';" v-for="(orderItem, index) in ordersWithMeals" v-bind:key="index">
          <!--                <pre>{{ orderItem }}</pre>-->
          <MealLabelLarge
            :productionPrefix="getPrefix(orderItem)"
            :page-number="getPageNumber(orderItem,index)"
            :meal-size="orderItem.meal_size"
            :get-best-before="getBestBefore(orderItem.order_date || orderItem.date)"
            :get-full-day="getFullDay(orderItem.order_date || orderItem.date)"
            :get-stream="getOrderStream(orderItem)"
            :allergies="formatAllergies(orderItem)"
            :is-chefs-choice="orderItem.stream==='chefs_choice'"
            :order-item="orderItem"
            :qr-code-content="generateQrCode(orderItem)"
          />
        </div>
      </template>
      <v-toolbar v-if="labelFormat==='direct'" flat>
        <v-spacer/>
        <v-btn :loading="generatingPDF" @click="downloadPDF($event.target, `download-${JSON.stringify($route.query)}`)">
          Download PDF
        </v-btn>
        <v-spacer/>
      </v-toolbar>
    </template>
  </div>
</template>
<script>
// "no pork" → "pork" (fed-lib restrictions-client restrictionLabel)
const withoutNo = (text) => String(text || '').replace(/\([^)]*\)/g, '').replace(/^no\s+/i, '').replace(/\s+/g, ' ').trim();

// import {mapGetters} from 'vuex';
// import moment from 'moment';
// import MealLabelSmall from '@/views/MealLabelSmall';
import MealLabelLarge from '@/views/MealLabelLarge';
import {mapActions, mapGetters} from 'vuex';
import {
  capitalise,
  dateFormatted,
  getBestBefore,
  getDateString,
  getFullDay,
  getProductionDays,
  shortenBin,
  todMapToString
} from '@/store/utils';
import urlState from "@/router/urlState";
import api from "@/api";
import moment from "moment/moment";
import ProductionSelector from "@/components/ProductionSelector.vue";
import diff from "microdiff";
import {claimPrintPage, releasePrintPage} from "@/utils/print-page";

// the on-screen sticker layout (labels.scss .fed-large-label) prints with the label's top margin
const STICKER_PRINT_PAGE = 'margin-top: 1.047cm; margin-bottom: 0';


export default {
  components: {
    ProductionSelector,
    MealLabelLarge
  },
  mixins: [urlState],

  async mounted() {
    if (this.basicView) {
      this.show = 'meals';
      this.excludeTags = ['DoNotPrint'];
      this.syncToUrl({
        param: 'forceSticker',
        urlParam: 'sticker',
        initFromRoute: true,
        parseCallback: (v) => v === 'true'
        // transformCallback: (v) => v === 'true'
      });
    }
    this.syncToUrl({
      param: 'show',
      urlParam: 'view',
      initFromRoute: true,
    });

    this.syncToUrl({
      param: 'searchEmail',
      urlParam: 'email',
      initFromRoute: true,
    });
    this.syncToUrl({
      param: 'searchName',
      urlParam: 'name',
      initFromRoute: true,
    });
    this.syncToUrl({
      param: 'labelFormat',
      urlParam: 'format',
      initFromRoute: true,
    });
    this.syncToUrl({
      param: 'excludeTags',
      urlParam: 'exclude',
      initFromRoute: true,
      parseCallback: (v) => (v || '').split(','),
      transformCallback: (v) => v && v.join(',')
    });
    this.syncToUrl({
      param: 'streamSelection',
      urlParam: 'streams',
      initFromRoute: true,
      parseCallback: (v) => (v || '').split(','),
      transformCallback: (v) => v && v.join(',')
    });
    this.syncToUrl({
      param: 'sizeSelection',
      urlParam: 'sizes',
      initFromRoute: true,
      parseCallback: (v) => (v || '').split(','),
      transformCallback: (v) => v && v.join(',')
    });
    this.syncToUrl({
      param: 'todSelection',
      urlParam: 'tod',
      initFromRoute: true,
      parseCallback: (v) => (v || '').split(','),
      transformCallback: (v) => v && v.join(',')
    });
    this.syncToUrl({
      param: 'restrictionFilter',
      urlParam: 'allergy_meals',
      initFromRoute: true,
      parseCallback: (v) => (v || '').split(','),
      transformCallback: (v) => v && v.join(',')
    });
    this.syncToUrl({
      param: 'dateSelection',
      urlParam: 'date_select',
      initFromRoute: true,
      parseCallback: (v) => {
        console.log('parse', v);
        return (v || '').split(',')
      },
      transformCallback: (v) => v && v.join(',')
    });
    this.syncToUrl({
      param: 'containerSizeSelection',
      urlParam: 'container_sizes',
      initFromRoute: true,
      parseCallback: (v) => (v || '').split(',').map(s => Number.parseInt(s)).filter(n => !isNaN(n)),
      transformCallback: (v) => v && v.join(',')
    });


    this.syncToUrl({
      param: 'pageSize',
      urlParam: 'page_size',
      initFromRoute: true,
      parseCallback: (v) => Number.parseInt(v)
    });

    this.syncToUrl({
      param: 'selectPage',
      urlParam: 'page',
      initFromRoute: true,
      parseCallback: (v) => v && Number.parseInt(v)
    });

    this.syncToUrl({
      param: 'selectedMealId',
      urlParam: 'meal',
      initFromRoute: true,
      parseCallback: (v) => v && Number.parseInt(v)
    });

    this.syncToUrl({
      param: 'showAll',
      urlParam: 'all',
      initFromRoute: true,
      parseCallback: (v) => v === 'true'
    });

    this.syncToUrl({
      param: 'dates',
      urlParam: 'dates',
      initFromRoute: true,
      parseCallback: (v) => Array.isArray(v) ? v : [v]
    });
    this.syncToUrl({
      param: 'production',
      urlParam: 'production',
      initFromRoute: true,
    });
    await this.fetchData();
  },
  beforeDestroy() {
    releasePrintPage('labels-stickers');
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData',
    labelFormat: {
      immediate: true,
      handler(format) {
        if (format === 'large') {
          claimPrintPage('labels-stickers', STICKER_PRINT_PAGE);
        } else {
          releasePrintPage('labels-stickers');
        }
      },
    },
    showDatePicker(v) {
      if (v) {
        if (this.isAdmin) {
          this.datePickerDate = this.dates;
        } else {
          this.datePickerDate = this.dates[0];
        }
      } else {
        if (this.isAdmin) {
          this.dates = this.datePickerDate;
        } else {
          this.dates = getProductionDays(this.datePickerDate);
        }
      }
      this.dates.sort();
    },
  },
  data() {
    return {
      loading: true,
      sizeSelection: [],
      dateSelection: [],
      streamSelection: [],
      todSelection: [],
      containerSizeSelection: [],
      substitutionSelection: [],
      showOrdersWithRestrictions: false,
      restrictionFilter: [],
      labelFormat: null,
      excludeTags: [],
      pageSize: null,
      selectPage: null,
      generatingPDF: null,
      show: null,
      selectedMealId: null,
      mealFilter: 'sleeve',
      showDatePicker: null,
      dates: [],
      forceSticker: false,
      datePickerDate: null,
      searchEmail: null,
      searchName: null,
      downloading: {},
      isAlreadyClicked: {},
      overrideMeals: {},
      selectMany: null,
      multiselect: {},
      downloadingMany: null,
      production: null,
      currentData: {dates: [], production: ''},
      ordersFetched: []
    }
  },
  computed: {
    ...mapGetters([
      'getDietName',
      'meals',
      'diets',
      'getMealsByDiet',
      'getDiet',
      'getDietStream',
      'getDietColor',
      'getStreams',
      'getTimeOfDay',
      'getSummaryForDiet',
      'getMeal',
      'getSubstitutionText',
      'getStreams'
    ]),
    hasStickerMeals() {
      return Object.entries(this.stickerMeals).length > 0;
    },
    hasSleeveMeals() {
      return Object.entries(this.sleeveMeals).length > 0;
    },
    hasNoneMeals() {
      return Object.entries(this.noneMeals).length > 0;
    },
    date() {
      return this.dateFrom;
      //return this.$route.params.date;
    },
    datesFormatted() {
      const format = 'dddd MMMM D';
      if (!this.dateFrom) {
        return '';
      } else if (this.dateFrom === this.dateTo) {
        return `${moment(this.dateFrom).format(format)}`;
      } else {
        return `${moment(this.dateFrom).format(format)} - ${moment(this.dateTo).format(format)}`
      }
    },
    dateFrom() {
      return [...this.dates].sort()[0];
    },
    dateTo() {
      return [...this.dates].sort().reverse()[0];
    },
    bestBeforeDate() {
      return getBestBefore(this.date);
    },
    fullDay() {
      return getFullDay(this.date);
    },
    meals() {
      if (this.mealFilter === 'sticker') {
        return this.stickerMeals;
      } else if (this.mealFilter === 'sleeve') {
        return this.sleeveMeals;
      } else if (this.mealFilter === 'none') {
        return this.noneMeals;
      } else {
        return this.allSizes;
      }
    },
    stickerMeals() {
      const mealsById = {};
      this.allOrders.forEach(o => {
        if (mealsById[o.meal_id] === undefined) {
          const meal = this.getMeal(o.meal_id);
          if (!meal) {
            console.warn('could not find meal', o.meal_id);
            return;
          }
          if (meal.print_option === 'sticker') {
            mealsById[o.meal_id] = meal;
          }
        }
      });
      return Object.values(mealsById).filter(m => !!m);
    },
    sleeveMeals() {
      const mealsById = {};
      this.allOrders.forEach(o => {
        if (mealsById[o.meal_id] === undefined) {
          const meal = this.getMeal(o.meal_id);
          if (!meal) {
            console.warn('could not find meal', o.meal_id);
            return;
          }
          // Group sleeve and not-set together
          if (meal.print_option === 'sleeve' || meal.print_option === 'not-set' || !meal.print_option) {
            mealsById[o.meal_id] = meal;
          }
        }
      });
      return Object.values(mealsById).filter(m => !!m);
    },
    noneMeals() {
      const mealsById = {};
      this.allOrders.forEach(o => {
        if (mealsById[o.meal_id] === undefined) {
          const meal = this.getMeal(o.meal_id);
          if (!meal) {
            console.warn('could not find meal', o.meal_id);
            return;
          }
          if (meal.print_option === 'none') {
            mealsById[o.meal_id] = meal;
          }
        }
      });
      return Object.values(mealsById).filter(m => !!m);
    },
    allSizes() {
      const mealsById = {};
      this.allOrders
        // .filter(o => o.meal.missing)
        .forEach(o => {
          if (mealsById[o.meal_id] === undefined) {
            const meal = this.getMeal(o.meal_id);
            if (!meal) {
              console.warn('could not find meal', o.meal_id);
              return;
            }
            mealsById[o.meal_id] = meal;
          }
        });
      console.log('meals', mealsById);
      return Object.values(mealsById).filter(m => !!m);
    },
    allOrders() {
      let orders = this.ordersFetched.slice();


      // duplicate orders so that there is one order object per quantity ordered
      orders = [
        ...orders
          .filter(order => order.quantity === 1),
        ...orders
          .filter(order => order.quantity > 1)
          .flatMap(order =>
            new Array(order.quantity)
              .fill({
                ...order,
                quantity: 1
              }))  // set qty to 1 to avoid count issues
      ];
      const ordersWithoutMissing = orders.filter(o => !!o.meal_id);

      if (ordersWithoutMissing.length !== orders.length) {
        const ordersWitMissing = orders.filter(o => !o.meal_id);
        console.log(`warning: ${orders.length - ordersWithoutMissing.length} orders are missing (out of ${orders.length}) because meal id missing`, {
          ordersWitMissing,
          orders,
          ordersWithoutMissing
        });
        alert(`warning: ${orders.length - ordersWithoutMissing.length} orders are missing (out of ${orders.length}) because meal could not be loaded`);
      }
      return ordersWithoutMissing;
    },
    extraOrders() {
      return this.allOrders.filter(o => (o.tod === 'extras' || o.tod === 'snacks'));
    },
    ordersFiltered() {
      let orders;
      orders = this.allOrders.slice();
      // console.log('all orders', {date: this.date, orders});
      // console.log('streams', this.streams)

      const excludeTags = this.excludeTags;
      if (excludeTags && excludeTags.length > 0) {
        // console.log('excluding', excludeTags)
        orders = orders.filter(o => !(o.tags && excludeTags.every(t => o.tags.includes(t))));
      }

      if (this.searchEmail) {
        const emails = this.searchEmail
          .split(',')
          .map(s => s.trim().toLowerCase())
          .filter(s => !!s)

        // eslint-disable-next-line no-inner-declarations
        function isMatch(email) {
          for (const matchEmail of emails) {
            if (email.toLowerCase().indexOf(matchEmail) > -1) {
              return true;
            }
          }
          return false;
        }

        orders = orders.filter(o => isMatch(o.email));
      }
      if (this.searchName) {
        const names = this.searchName
          .split(',')
          .map(s => s.trim().toLowerCase())
          .filter(s => !!s)

        // eslint-disable-next-line no-inner-declarations
        function isMatch(n) {
          for (const m of names) {
            if (n.toLowerCase().indexOf(m) > -1) {
              return true;
            }
          }
          return false;
        }

        orders = orders.filter(o => isMatch([o.first_name, o.last_name].join(' ')));
      }
      if (this.selectMany) {
        const keys = Object.keys(this.multiselect)
          .filter(k => this.multiselect[k]);
        const selectedOrders = [];
        for (const key of keys) {
          let [mealId, type] = key.split('-');
          mealId = Number.parseInt(mealId)
          if (type === 'restricted') {
            selectedOrders.push(...orders
              .filter(o => o.meal_id === mealId && o.allergyDetected)
            )
          } else {
            const meal_size = type;
            selectedOrders.push(...orders
              .filter(o => o.meal_id === mealId && o.meal_size === meal_size && !o.allergyDetected)
            )
          }
        }
        orders = selectedOrders;
      } else if (this.showAll) {
        orders = orders.filter(o => (o.tod !== 'extras' && o.tod !== 'snack'));
      } else if (this.showMeals) {
        if (this.selectedMealId) {
          orders = orders.filter(o => o.meal_id === this.selectedMealId)
        }
        if (this.showOrdersWithRestrictions) {
          orders = orders.filter(o => o.allergyDetected);
        } else {
          orders = orders.filter(o => !o.allergyDetected);
        }
        console.log('filters', [this.sizeSelection, this.streamSelection, this.todSelection]);
        orders = orders.filter(o =>
          (this.sizeSelection.length === 0 || this.sizeSelection.includes(o.meal_size))
        );
      } else {
        // this is the apply filter view (filter === 'show')
        if (this.restrictionFilter && this.restrictionFilter.length > 0) {
          const noAllergy = this.restrictionFilter.find(s => s === 'no-allergy');
          const noActiveAllergy = this.restrictionFilter.find(s => s === 'no-active-allergy');
          const activeAllergy = this.restrictionFilter.find(s => s === 'active-allergy');
          const hasAllergySet = o => (o.allergies && o.allergies.length > 0);
          orders = orders.filter(o => {
            if (hasAllergySet(o)) {
              // order has allergy defined
              if (o.allergyDetected) {
                // order has allergy detected
                if (activeAllergy) {
                  return true;
                }
              } else {
                // order allergy defined but not active
                if (noActiveAllergy) {
                  return true;
                }
              }
            } else {
              if (noAllergy) {
                return true;
              }
            }
            return false;
          })
        }
        console.log('filters', [this.sizeSelection, this.streamSelection, this.todSelection, this.dateSelection, this.containerSizeSelection]);
        orders = orders.filter(o => {
          const meal = this.getMeal(o.meal_id);
          const containerSize = meal ? meal.container_size : null;
          return (this.sizeSelection.includes(o.meal_size)) &&
            (this.todSelection.includes(o.tod)) &&
            (this.streamSelection.includes(o.stream)) &&
            (this.dateSelection.includes(o.date)) &&
            (this.containerSizeSelection.length === 0 || this.containerSizeSelection.includes(containerSize));
        });
      }


      console.log('filtered orders', {
        date: this.date,
        orders
      });
      return orders;
    },
    orders() {
      let orders = this.ordersFiltered;
      if (this.pageSize) {
        if (this.selectPage !== null) {
          const start = this.selectPage * this.pageSize;
          const end = (start + this.pageSize);
          console.log('showing from ', {
            start,
            end
          });
          orders = orders.slice(start, end);
        } else {
          orders = [];
        }
      }
      return orders;
    },
    ordersWithMeals() {
      if (this.loading) {
        return [];
      } else {
        return this.orders.filter(o => !o.meal.missing);
      }
    },
    mealsNotFound() {
      const mealIds = {};
      this.orders
        .filter(o => o.meal.missing)
        .forEach(o => mealIds[o.meal_id] = (mealIds[o.meal_id] || 0) + 1);
      console.log('mealsNotFound', mealIds);
      return mealIds;
    },
    streams() {
      const streams = this.getStreams();  //Object.values(this.diets).map(diet => JSON.stringify(diet.name));
      console.log('streams', streams);
      return streams;
    },
    missingBinAssignments() {
      return (this.ordersFetched || []).filter(o => !o.bin);
    },
    customerTags() {
      const tags = new Set();
      this.allOrders.forEach(o => {
        if (o.tags) {
          o.tags.forEach(t => tags.add(t));
        }
      })
      return [...tags];
    },
    tods() {
      return [...new Set(['breakfast', 'lunch', 'dinner', 'extras', ...this.allOrders.map(o => o.tod)])];
    },
    containerSizes() {
      const sizes = new Set();
      this.allOrders.forEach(o => {
        const meal = this.getMeal(o.meal_id);
        if (meal && meal.container_size !== null && meal.container_size !== undefined) {
          sizes.add(meal.container_size);
        }
      });
      return [...sizes].sort((a, b) => a - b);
    },
    pageCount() {
      return (this.pageSize) ? Math.ceil(this.ordersFiltered.length / this.pageSize) : 1;
    },
    pages() {
      const result = [];
      if (this.pageSize) {
        let page = 0;
        let pages = this.pageCount;
        while (page++ < pages) {
          result.push(page)
        }
      }
      return result;
    },
    showAll() {
      return this.show === 'all';
    },
    showFilter() {
      return this.show === 'filter'
    },
    showMeals() {
      return !this.loading && this.show === 'meals';
    },
    getDatesInRange() {
      const dates = [];
      if (!this.dateFrom || !this.dateTo) {
        return dates;
      }
      const from = moment(this.dateFrom);
      const to = moment(this.dateTo);

      const diff = moment.duration(to.diff(from));
      if (diff.asDays() >= 0 && diff.asDays() <= 31) {
        // console.log('adding days ', {from, to})
        while (from.isSameOrBefore(to)) {
          const dateString = getDateString(from);
          // console.log('added date', dateString);
          dates.push(dateString);
          from.add(1, 'day');
        }
      } else {
        window.alert(diff.asDays() + ' days is above the limit of 7');
      }
      // console.log('getDatesInRange', dates);
      return dates;
    },
    selectedCount() {
      return Object.values(this.multiselect).filter(v => !!v).length
    },
    hasMissingBinAssignment() {
      return this.missingBinAssignments.length > 0;
    },
    alreadyClickedStorageKey() {
      return `PROD-${this.production}-${this.dates.join('-')}-labels`;
    },
    productionPrefix() {
      return `${this.production[0]}-`.toUpperCase();
    },
    activeStreams() {
      const activeStreams = new Set(this.ordersFetched.map(o => o.stream));
      return Object.values(this.streams).filter(s => activeStreams.has(s.id));
    },
    // Sleeve progress metrics
    sleeveTotal() {
      let total = 0;
      this.allOrders.forEach(o => {
        const meal = this.getMeal(o.meal_id);
        if (meal && (meal.print_option === 'sleeve' || meal.print_option === 'not-set' || !meal.print_option)) {
          if (o.allergyDetected) {
            total += 1;
          } else {
            total += 1;
          }
        }
      });
      return total;
    },
    sleevePrinted() {
      let printed = 0;
      this.allOrders.forEach(o => {
        const meal = this.getMeal(o.meal_id);
        if (meal && (meal.print_option === 'sleeve' || meal.print_option === 'not-set' || !meal.print_option)) {
          let options;
          if (o.allergyDetected) {
            options = {restricted: true};
          } else {
            options = {mealSize: o.meal_size};
          }
          const key = this.getKey(o.meal_id, options);
          if (this.isAlreadyClicked[key]) {
            printed += 1;
          }
        }
      });
      return printed;
    },
    sleeveProgress() {
      if (this.sleeveTotal === 0) return 0;
      return Math.round((this.sleevePrinted / this.sleeveTotal) * 100);
    },
    sleeveLabelTypesTotal() {
      const labelTypes = new Set();
      this.allOrders.forEach(o => {
        const meal = this.getMeal(o.meal_id);
        if (meal && (meal.print_option === 'sleeve' || meal.print_option === 'not-set' || !meal.print_option)) {
          let options;
          if (o.allergyDetected) {
            options = {restricted: true};
          } else {
            options = {mealSize: o.meal_size};
          }
          const key = this.getKey(o.meal_id, options);
          labelTypes.add(key);
        }
      });
      return labelTypes.size;
    },
    sleeveLabelTypesPrinted() {
      const labelTypes = new Set();
      this.allOrders.forEach(o => {
        const meal = this.getMeal(o.meal_id);
        if (meal && (meal.print_option === 'sleeve' || meal.print_option === 'not-set' || !meal.print_option)) {
          let options;
          if (o.allergyDetected) {
            options = {restricted: true};
          } else {
            options = {mealSize: o.meal_size};
          }
          const key = this.getKey(o.meal_id, options);
          labelTypes.add(key);
        }
      });

      let printed = 0;
      labelTypes.forEach(key => {
        if (this.isAlreadyClicked[key]) {
          printed += 1;
        }
      });
      return printed;
    },
    sleeveLabelTypesProgress() {
      if (this.sleeveLabelTypesTotal === 0) return 0;
      return Math.round((this.sleeveLabelTypesPrinted / this.sleeveLabelTypesTotal) * 100);
    },
    // Sticker progress metrics
    stickerTotal() {
      let total = 0;
      this.allOrders.forEach(o => {
        const meal = this.getMeal(o.meal_id);
        if (meal && meal.print_option === 'sticker') {
          if (o.allergyDetected) {
            total += 1;
          } else {
            total += 1;
          }
        }
      });
      return total;
    },
    stickerPrinted() {
      let printed = 0;
      this.allOrders.forEach(o => {
        const meal = this.getMeal(o.meal_id);
        if (meal && meal.print_option === 'sticker') {
          let options;
          if (o.allergyDetected) {
            options = {restricted: true};
          } else {
            options = {mealSize: o.meal_size};
          }
          const key = this.getKey(o.meal_id, options);
          if (this.isAlreadyClicked[key]) {
            printed += 1;
          }
        }
      });
      return printed;
    },
    stickerProgress() {
      if (this.stickerTotal === 0) return 0;
      return Math.round((this.stickerPrinted / this.stickerTotal) * 100);
    },
    stickerLabelTypesTotal() {
      const labelTypes = new Set();
      this.allOrders.forEach(o => {
        const meal = this.getMeal(o.meal_id);
        if (meal && meal.print_option === 'sticker') {
          let options;
          if (o.allergyDetected) {
            options = {restricted: true};
          } else {
            options = {mealSize: o.meal_size};
          }
          const key = this.getKey(o.meal_id, options);
          labelTypes.add(key);
        }
      });
      return labelTypes.size;
    },
    stickerLabelTypesPrinted() {
      const labelTypes = new Set();
      this.allOrders.forEach(o => {
        const meal = this.getMeal(o.meal_id);
        if (meal && meal.print_option === 'sticker') {
          let options;
          if (o.allergyDetected) {
            options = {restricted: true};
          } else {
            options = {mealSize: o.meal_size};
          }
          const key = this.getKey(o.meal_id, options);
          labelTypes.add(key);
        }
      });

      let printed = 0;
      labelTypes.forEach(key => {
        if (this.isAlreadyClicked[key]) {
          printed += 1;
        }
      });
      return printed;
    },
    stickerLabelTypesProgress() {
      if (this.stickerLabelTypesTotal === 0) return 0;
      return Math.round((this.stickerLabelTypesPrinted / this.stickerLabelTypesTotal) * 100);
    }
  },
  methods: {
    ...mapActions([
      'fetchDiets',
      'fetchStreams',
      'fetchMeal',
      'fetchRestrictions'
    ]),
    formatDate: dateFormatted,
    todMapToString(i) {
      return todMapToString[i] || i;
    },
    getFullDay,
    getBestBefore,
    getOrderStream(orderItem) {
      const stream = this.streams[(orderItem.order_stream || orderItem.stream)] || {name: (orderItem.order_stream || orderItem.stream)}
      if (orderItem.is_allergy_substitution) {
        return {name: `${stream.name} (custom)`}
      } else {
        return stream;
      }
    },
    async fetchData() {
      const dates = this.dates;
      const production = this.production;
      this.multiselect = {};
      // const value = `M-${mealId}-${JSON.stringify(options)}`;

      if (!dates || dates.length === 0) {
        console.log('no dates, no fetch');
        this.loading = false;
        return;
      }
      if (!production) {
        console.log('no production, no fetch');
        this.loading = false;
        return;
      }

      if (diff(this.currentData, {dates, production}).length === 0) {
        // console.log('already loaded', this.currentData);
        return
      } else {
        console.log('fetching prep', {dates, production});
        this.currentData = {dates, production};
      }

      this.error = this.post = null
      console.log('fetching data ', {date: this.date});
      this.loading = true;


      const orders = await api
        .get('v2/order/search', {
          params: {
            from: this.dateFrom,
            to: this.dateTo,
            productions: [this.production],
            // properties: ['quantity', 'allergyDetected', 'allergies', 'meal_id', 'stream', 'tod', 'meal_size'],
          }
        })
        .then(({data}) => data);


      // Load existing print state from API first
      let existingStates = {};
      try {
        const response = await api.get('v2/label/print-state', {
          params: {
            production: this.production,
            dates: this.dates.join(',')
          }
        });
        existingStates = response.data || {};
        // Response format: { "M-123-{\"mealSize\":\"small\"}": {printed: true/false, meal_name: "...", label_type: "small"}, ... }
      } catch (error) {
        console.error('Failed to load print state from API:', error);
      }

      // Build list of all label types needed from orders
      const labelTypesNeeded = new Set();
      const currentKeys = new Set();
      orders.forEach(order => {
        if (order.meal_id) {
          let key, label_type;
          if (order.allergyDetected) {
            key = this.getKey(order.meal_id, {restricted: true});
            label_type = 'restricted';
          } else {
            key = this.getKey(order.meal_id, {mealSize: order.meal_size});
            label_type = order.meal_size;
          }

          currentKeys.add(key);

          // Only add if it doesn't already exist
          if (!existingStates[key]) {
            labelTypesNeeded.add(JSON.stringify({meal_id: order.meal_id, label_type}));
          }
        }
      });

      // Find keys in existingStates that are no longer needed
      const keysToRemove = Object.keys(existingStates).filter(key => !currentKeys.has(key));

      if (keysToRemove.length > 0) {
        if (currentKeys.size === keysToRemove.length) {
          alert('it seems the orders did not load correctly');
        } else if (confirm(
          `It appears that some meals no longer have orders.  Do you want to forget the print status for these?
          (if orders are added again, they will no longer show as printed)`)) {
          console.log('Removing print states for keys no longer needed:', keysToRemove);


          // Convert keys back to meal_id and label_type format
          const statesToRemove = keysToRemove.map(key => {
            // Parse key like "M-123-{\"mealSize\":\"small\"}" or "M-123-{\"restricted\":true}"
            const match = key.match(/^M-(\d+)-(.+)$/);
            if (match) {
              const meal_id = parseInt(match[1]);
              const options = JSON.parse(match[2]);
              const label_type = options.restricted ? 'restricted' : options.mealSize;
              return {meal_id, label_type};
            }
            return null;
          }).filter(s => s !== null);

          try {
            await api.delete('v2/label/print-state', {
              data: {
                production: this.production,
                dates: this.dates,
                states: statesToRemove
              }
            });
          } catch (error) {
            console.error('Failed to remove unused print states:', error);
          }
        }
      }

      orders.filter(o => !o.meal_id).forEach(o => console.warn('no meal id for order', o));
      const mealIds = [...new Set(orders.map(o => o.meal_id).filter(Boolean))];
      await Promise
        .all([
          ...mealIds.map(mealId => {
            // a meals-by-date fetch may have overwritten the cached meal with a
            // summary row that has no ingredients — force a full re-fetch
            const cached = this.$store.state.meal[mealId];
            const force = !cached || !cached.ingredients;
            return this.fetchMeal({id: mealId, force}).catch(e => {
              console.warn('failed to fetch meal ' + mealId, e);
            });
          }),
          this.fetchDiets(),
          this.fetchStreams(),
          this.fetchRestrictions()
        ])
        .catch(e => {
          console.error('failed loading data', e);
          alert('error: ' + e);
          throw e;
        });

      // set the meal
      orders.forEach(o => {
        o.meal = this.getMeal(o.meal_id);
        if (!o.meal) {
          o.meal = {
            name: 'could not find meal id ' + o.meal_id,
            missing: true
          };
        }
      });
      orders.forEach(o => {
          // `allergies` the kitchen substitutes; `allergyWarningIds` are
          // delivered as-is (the customer's allergy_settings, or a chef's
          // choice product) and print as "contains …" when the meal holds them
          const restrictions = [...(o.allergies || []), ...(o.allergyWarningIds || [])];
          // sort value: no allergies (-1) < no matched allergies (0) < matched allergies (1)
          if (restrictions.length === 0) {
            o.restrictionSort = -1;
          } else {
            o.restrictionSort = (o.restrictedFoods || o.allergyWarnings) ? 1 : 0;
          }
          o.restrictionTagsText = new Map(
            restrictions
              .map(a => [a, this.restrictionLabelFor(o, a)])
              .sort((a, b) => a[1].localeCompare(b[1]))
          )
        }
      );
      orders.forEach(o => o.restrictionTagsString = Object.values(o.restrictionTagsText).join(','));
      orders.forEach(o => o.streamName = (this.streams[o.stream] || {name: o.order_type}).name);
      orders.forEach(o => o.isMultiplePersonMeal = (o.meal && o.meal.name && o.meal.name.match(/\d+ person/i) && o.meal.name));

      orders.sort((a, b) => {
        if (a.isMultiplePersonMeal && !b.isMultiplePersonMeal) {
          return -1;
        }
        if (!a.isMultiplePersonMeal && b.isMultiplePersonMeal) {
          return 1;
        }
        if (a.isMultiplePersonMeal && b.isMultiplePersonMeal) {
          return a.isMultiplePersonMeal.localeCompare(b.isMultiplePersonMeal);
        }
        const nameA = a.streamName;
        const nameB = b.streamName;
        if (nameA !== nameB) {
          return nameA.localeCompare(nameB);
        }

        const aName = `${a.meal.name}-${a.meal_id}`;
        const bName = `${b.meal.name}-${b.meal_id}`;
        if (aName !== bName) {
          return aName.localeCompare(bName);
        }
        if (a.meal.tod !== b.meal.tod) {
          return a.meal.tod - b.meal.tod;
        }
        if (a.restrictionSort !== b.restrictionSort) {
          return a.restrictionSort - b.restrictionSort
        }
        if (a.restrictionTagsString !== b.restrictionTagsString) {
          return a.restrictionTagsString.localeCompare(b.restrictionTagsString);
        }
        if (a.meal_size !== b.meal_size) {
          // note reverse compare, as (s)mall, (m)edium, (l
          return b.meal_size.localeCompare(a.meal_size);
        }
        return `${a.first_name} ${a.last_name}`.localeCompare(`${b.first_name} ${b.last_name}`);
      });
      this.ordersFetched = orders;

      this.$nextTick(() => {
        if (this.mealFilter === 'sleeve' && !this.hasSleeveMeals) {
          this.mealFilter = ''
        }
        if (this.mealFilter === 'sticker' && !this.hasStickerMeals) {
          this.mealFilter = ''
        }
      })

      // Initialize unprinted records for new label types only
      if (labelTypesNeeded.size > 0) {
        const states = Array
          .from(labelTypesNeeded)
          .map(str => {
            const obj = JSON.parse(str);
            return {
              meal_id: obj.meal_id,
              label_type: obj.label_type,
              isPrinted: false
            };
          })
          .filter(({meal_id}) => !!this.getMeal(meal_id));

        try {
          await api.post('v2/label/print-state', {
            production: this.production,
            dates: this.dates,
            states
          });
        } catch (error) {
          console.error('Failed to initialize print states:', error);
        }
      }


      // Reload print state after initialization
      try {
        this.isAlreadyClicked = {};
        const response = await api.get('v2/label/print-state', {
          params: {
            production: this.production,
            dates: this.dates.join(',')
          }
        });
        const current = response.data || {}
        Object.entries(current).forEach(([key, state]) => {
          this.$set(this.isAlreadyClicked, key, state.printed);
        });
      } catch (error) {
        alert('Failed to load print state from API:' + error);
      }

      this.loading = false;
    },
    formatAllergies(orderItem) {
      return orderItem.restrictionTagsText;
      // return (orderItem.allergies || []).map(a => this.getSubstitutionText(a));
    },
    // a restriction found in a meal that is delivered as-is (allergyWarnings)
    containsRestriction(orderItem, restrictionId) {
      return !!(orderItem.allergyWarnings && orderItem.allergyWarnings[restrictionId]);
    },
    // the label's text for a restriction: "no pork" as usual, "pork" when the
    // label will say "contains pork"
    restrictionLabelFor(orderItem, restrictionId) {
      const text = this.getSubstitutionText(restrictionId);
      return this.containsRestriction(orderItem, restrictionId) ? withoutNo(text) : text;
    },
    generateQrCode(orderItem) {
      const size = orderItem.meal_size.substring(0, 1).toLowerCase();
      // const bin = orderItem.bin ? `?bin=${orderItem.bin}` : '';
      if (orderItem.squid) {
        return `https://fed.fyi/#/s/${orderItem.squid}`;
      } else {
        const mealId = orderItem.meal_id;
        return `https://fed.fyi/#/chart/fedfedfed/${mealId}/${size}`;
      }
    },
    labelFilename() {
      let isWindows = true;
      try {
        if (navigator.platform.indexOf('Win') === -1) {
          isWindows = false;
        }
      } catch (e) {
        console.error('could not detect os')
      }

      const {
        excludeTags,
        streamSelection,
        sizeSelection,
        todSelection,
        pageSize,
        selectPage,
        pageCount,
        showOrdersWithRestrictions,
        showAll,
        showMeals,
        date
      } = this;

      const filenameParts = [];
      filenameParts.push(date);
      filenameParts.push(moment(date).format('ddd'));
      filenameParts.push(this.production);
      if (showAll) {
        filenameParts.push('all');
      } else {
        if (showMeals) {
          if (this.selectMany) {
            const keys = Object.keys(this.multiselect)
              .filter(k => this.multiselect[k])
              .map(s => `M${s}`);
            filenameParts.push(...keys);
          } else if (this.selectedMealId) {
            const meal = this.getMeal(this.selectedMealId);
            const dietName = this.getDietName(meal.diet);
            filenameParts.push(...dietName.split(' '));
            filenameParts.push(`M${meal.id}`);
          }
        }

        if (showOrdersWithRestrictions) {
          filenameParts.push('restrictions');
        }

        if (streamSelection.length > 0) {
          filenameParts.push(...streamSelection)
        }
        if (todSelection.length > 0) {
          filenameParts.push(...todSelection)
        }
        if (sizeSelection.length > 0) {
          filenameParts.push(...sizeSelection)
        }
        if (excludeTags.length > 0) {
          filenameParts.push(...excludeTags.map(t => `exclude-${t}`));
        }
        if (pageSize) {
          filenameParts.push(`page-${selectPage + 1}-of-${pageCount}`);
        }
      }
      const filename = `${filenameParts.join('-')}`;
      if (isWindows && filename.length > 245) {
        return filename.slice(0, 245) + '(clip).pdf';
      } else {
        return `${filename}.pdf`;
      }
    },
    async downloadPDF(element, clickKey) {
      console.log('download pdf', clickKey);
      if (clickKey) {
        if (this.isAlreadyClicked[clickKey]) {
          console.log('already downloaded', clickKey);
          return;
        } else {
          console.log('not already downloaded', clickKey, this.isAlreadyClicked[clickKey]);
          this.$set(this.isAlreadyClicked, clickKey, true);
        }
      }
      await this.$nextTick();
      const orders = this.ordersWithMeals;
      if (orders.length === 0) {
        alert('No meals selected, nothing to print');
        return false;
      }

      // use a sticker if sticker
      const useSticker = this.forceSticker || orders.some(o => {
        const meal = o.meal;
        return meal && meal.print_option === 'sticker';
      });
      const allSticker = this.forceSticker || orders.every(o => {
        const meal = o.meal;
        return meal && meal.print_option === 'sticker';
      });

      if (useSticker && !allSticker) {
        alert('Warning:  some meal order needed sticker and some did not!  This should never happen');
      }

      const payload = [];
      let index = 0;
      this.generatingPDF = true;

      let lastMealId;
      for (const orderItem of orders) {
        if (lastMealId !== orderItem.meal.id) {
          index = 0;
          lastMealId = orderItem.meal.id;
        }
        const ingredients = (orderItem.meal.ingredients || []).map(ingredient => ({
          isRestricted: orderItem.restrictedFoods && orderItem.restrictedFoods[ingredient.food_id],
          name: ingredient.name
        }));
        const restrictions = [];
        if (orderItem.restrictionTagsText) {
          for (const key of orderItem.restrictionTagsText.keys()) {
            const val = orderItem.restrictionTagsText.get(key);
            restrictions.push({
              name: val,
              detected: !!(orderItem.allergyDetected && orderItem.allergyDetected[key]),
              contains: this.containsRestriction(orderItem, key)
            });
          }
        }
        let stream = (this.streams[orderItem.order_stream || orderItem.stream] || {name: orderItem.stream}).name;
        if (stream === 'chefs_choice') {
          stream = `Chef's Choice`;
        }

        if (orderItem.is_allergy_substitution) {
          stream = `${stream} (custom)`;
        }

        // filter out blank lines
        let instructions = (orderItem.meal.instructions || []).map(i => i.trim()).filter(i => !!i);

        if (useSticker) {
          // Build sticker format
          const ingredientsStr = (orderItem.meal.ingredients || []).map(ingredient => {
            const isRestricted = orderItem.restrictedFoods && orderItem.restrictedFoods[ingredient.food_id];
            return isRestricted ? `<span class="strike">${ingredient.name}</span>` : ingredient.name;
          }).join(', ');

          const sticker = {
            day: getFullDay(orderItem.order_date || orderItem.date),
            bestBefore: getBestBefore(orderItem.order_date || orderItem.date),
            size: capitalise(orderItem.meal_size),
            tod: capitalise(orderItem.order_tod || orderItem.tod),
            stream,
            customerName: `${orderItem.first_name} ${orderItem.last_name}`,
            mealName: orderItem.meal.name,
            ingredients: ingredientsStr,
            instructions: instructions,
            hasMultipleInstructions: instructions.length > 1,
            bin: this.getPrefix(orderItem) + shortenBin(orderItem.bin || ''),
            showTruck: orderItem.shipping_group !== 'local',
            pageNumber: this.getPageNumber(orderItem, index),
            restrictions,
            qrcodeUrl: this.generateQrCode(orderItem),
            noTreeNuts: false // TODO: determine based on meal data
          };
          payload.push(sticker);
        } else {
          // Build regular label format
          const label = {
            day: getFullDay(orderItem.order_date || orderItem.date),
            bestBefore: getBestBefore(orderItem.order_date || orderItem.date),
            size: capitalise(orderItem.meal_size),
            tod: capitalise(orderItem.order_tod || orderItem.tod),
            stream,
            customerName: `${orderItem.first_name} ${orderItem.last_name}`,
            mealName: orderItem.meal.name,
            ingredients,
            directions: instructions.join('<br/>'),
            labelId: this.getPageNumber(orderItem, index),
            mealId: `M${orderItem.meal.id}`,
            filingId: this.getPrefix(orderItem) + shortenBin(orderItem.bin || ''),
            restrictions,
            qrcodeUrl: this.generateQrCode(orderItem),
            showTruck: orderItem.shipping_group !== 'local'
          };
          payload.push(label);
        }

        index++;
      }

      try {
        // Wrap stickers in a stickers property if using sticker format
        const requestBody = useSticker ? {stickers: payload} : payload;
        const response = await api.post('v2/label/pdf', requestBody, {responseType: 'blob'});
        const blob = new Blob([response.data], {type: response.headers['content-type']});
        const link = document.createElement('a');
        if (element) {
          // this prevents the page from jumping when the click event happens
          element.parentElement.appendChild(link);
        }

        link.href = URL.createObjectURL(blob);
        link.download = this.labelFilename();
        // maybe this will stop it downloading many times?
        link.click();
        URL.revokeObjectURL(link.href);
        this.generatingPDF = false;
        this.$nextTick(() => this.isAlreadyClicked[clickKey] = false);
        return true;
      } catch (e) {
        this.generatingPDF = false;
        console.error('failed', e);
        this.$nextTick(() => this.isAlreadyClicked[clickKey] = false);
        return false;
      }

    },
    getPrefix(orderItem) {
      return `${(orderItem.shipping_group || '?')[0]}-`.toUpperCase();
    },
    getPageNumber(orderItem, index) {
      if (this.pageSize) {
        return [`${orderItem.meal.id}`.padStart(4, '0'), this.selectPage + 1, this.pageCount, `${index + 1001}`.padStart(4, '0')].join('-')
      } else {
        return [`${orderItem.meal.id}`.padStart(4, '0'), `${index + 1001}`.padStart(4, '0')].join('-')
      }
    },

    getCountBySize(mealId, mealSize) {
      let orders = this.allOrders;
      const excludeTags = this.excludeTags;
      if (excludeTags && excludeTags.length > 0) {
        // console.log('excluding', excludeTags)
        orders = orders.filter(o => !(o.tags && excludeTags.every(t => o.tags.includes(t))));
      }
      return orders
        .filter(o => o.meal_id === mealId)
        .filter(o => o.meal_size === mealSize)
        .filter(o => !o.allergyDetected)
        .reduce((sum, o) => sum + o.quantity, 0);
    },
    getCountByRestrictions(mealId) {
      let orders = this.allOrders;
      const excludeTags = this.excludeTags;
      if (excludeTags && excludeTags.length > 0) {
        // console.log('excluding', excludeTags)
        orders = orders.filter(o => !(o.tags && excludeTags.every(t => o.tags.includes(t))));
      }
      return orders
        .filter(o => o.meal_id === mealId)
        .filter(o => o.allergyDetected)
        .reduce((sum, o) => sum + o.quantity, 0);
    },
    async multiselectDownload() {
      this.$nextTick(async () => {
        if (await this.downloadPDF()) {
          const keys = Object.keys(this.multiselect)
            .filter(k => this.multiselect[k]);

          // Save each state change individually to API
          for (const key of keys) {
            let [mealId, type] = key.split('-');
            mealId = Number.parseInt(mealId);
            const options = {};
            if (type === 'restricted') {
              options.restricted = true;
            } else {
              const meal_size = type;
              options.mealSize = meal_size;
            }
            this.multiselect[key] = false;

            // Save single state to API with isPrinted: true
            try {
              await api.post('v2/label/print-state', {
                production: this.production,
                dates: this.dates,
                states: [{
                  meal_id: mealId,
                  label_type: type,
                  isPrinted: true
                }]
              });
            } catch (error) {
              alert('Failed to save print state to API: ' + error);
            }
          }

          // Refetch all states after saving
          try {
            const response = await api.get('v2/label/print-state', {
              params: {
                production: this.production,
                dates: this.dates.join(',')
              }
            });
            this.isAlreadyClicked = {};
            const current = response.data || {}
            Object.entries(current).forEach(([key, state]) => {
              this.$set(this.isAlreadyClicked, key, state.printed);
            });
          } catch (error) {
            console.error('Failed to refetch print state from API:', error);
          }
        } else {
          console.warn('this download returned false');
        }
        this.downloadingMany = false;
        this.selectMany = false;
      })
      // reset override
      this.overrideMeals = {};
      this.downloadingMany = true;
    },

    async selectDownloadDisable(mealId, options, $event) {
      console.log('selectDownloadDisable', {mealId, options, $event});
      const {
        mealSize,
        restricted
      } = options;

      this.selectedMealId = mealId;
      this.sizeSelection = [];
      this.showOrdersWithRestrictions = !!restricted;
      let key;
      let labelType;
      if (mealSize) {
        key = `${mealId}-${mealSize}`;
        labelType = mealSize;
        this.sizeSelection = [mealSize];
      } else if (restricted) {
        key = `${mealId}-restricted`;
        labelType = 'restricted';
      }
      if (this.downloading[key]) {
        console.log('this.downloading[key] - already downloading', this.downloading[key]);
        return;
      }

      // Check if already clicked and warn
      const clickKey = this.getKey(mealId, options);
      if (this.isAlreadyClicked[clickKey]) {
        if (!confirm(clickKey + ' - These labels have already been printed. Do you want to print them again?')) {
          return;
        } else {
          this.isAlreadyClicked[clickKey] = false;
        }
      }

      if (key) {
        this.$set(this.downloading, key, true);
      }

      this.$nextTick(async () => {
        if (await this.downloadPDF($event.target, clickKey)) {
          // Save single state to API with isPrinted: true
          try {
            await api.post('v2/label/print-state', {
              production: this.production,
              dates: this.dates,
              states: [{
                meal_id: mealId,
                label_type: labelType,
                isPrinted: true
              }]
            });
          } catch (error) {
            console.error('Failed to save print state to API:' + error);
          }

          // Refetch all states after saving
          try {
            const response = await api.get('v2/label/print-state', {
              params: {
                production: this.production,
                dates: this.dates.join(',')
              }
            });
            this.isAlreadyClicked = {};
            const current = response.data || {}
            Object.entries(current).forEach(([key, state]) => {
              this.$set(this.isAlreadyClicked, key, state.printed);
            });
          } catch (error) {
            console.error('Failed to refetch print state from API:', error);
          }

          await this.$nextTick();
          if (key) {
            this.$set(this.downloading, key, false);
          }
        } else {
          console.warn('this download returned false');
          await this.$nextTick();
          if (key) {
            this.$set(this.downloading, key, false);
          }
        }
      })
    },
    closeDatePicker() {
      this.showDatePicker = false;
      this.$nextTick(() => this.fetchData());
    },
    getKey(mealId, options) {
      return `M-${mealId}-${JSON.stringify(options)}`;
    },
    selectAll() {
      // Select all available buttons for all meals
      this.meals.forEach(meal => {
        if (this.mealFilter !== 'none') {
          if (this.getCountBySize(meal.id, 'small') > 0) {
            this.$set(this.multiselect, `${meal.id}-small`, true);
          }
          if (this.getCountBySize(meal.id, 'medium') > 0) {
            this.$set(this.multiselect, `${meal.id}-medium`, true);
          }
          if (this.getCountBySize(meal.id, 'large') > 0) {
            this.$set(this.multiselect, `${meal.id}-large`, true);
          }
          if (this.getCountByRestrictions(meal.id) > 0) {
            this.$set(this.multiselect, `${meal.id}-restricted`, true);
          }
        }
      });
    },
    deselectAll() {
      // Deselect all buttons
      Object.keys(this.multiselect).forEach(key => {
        this.$set(this.multiselect, key, false);
      });
    },
    selectAllForMeal(mealId) {
      // Select all available buttons for a specific meal
      if (this.mealFilter !== 'none') {
        if (this.getCountBySize(mealId, 'small') > 0) {
          this.$set(this.multiselect, `${mealId}-small`, true);
        }
        if (this.getCountBySize(mealId, 'medium') > 0) {
          this.$set(this.multiselect, `${mealId}-medium`, true);
        }
        if (this.getCountBySize(mealId, 'large') > 0) {
          this.$set(this.multiselect, `${mealId}-large`, true);
        }
        if (this.getCountByRestrictions(mealId) > 0) {
          this.$set(this.multiselect, `${mealId}-restricted`, true);
        }
      }
    },
    hasMulitpleButtonsForMeal(mealId) {
      // Check if a meal has more than one button (size or restriction)
      let buttonCount = 0;
      if (this.getCountBySize(mealId, 'small') > 0) buttonCount++;
      if (this.getCountBySize(mealId, 'medium') > 0) buttonCount++;
      if (this.getCountBySize(mealId, 'large') > 0) buttonCount++;
      if (this.getCountByRestrictions(mealId) > 0) buttonCount++;
      return buttonCount > 1;
    },
    hasAnyAlreadyClicked(mealId) {
      // Check if any checkbox for this meal has been clicked
      const sizes = ['small', 'medium', 'large'];
      for (const size of sizes) {
        if (this.getCountBySize(mealId, size) > 0) {
          const key = this.getKey(mealId, {mealSize: size});
          if (this.isAlreadyClicked[key]) {
            return true;
          }
        }
      }
      if (this.getCountByRestrictions(mealId) > 0) {
        const key = this.getKey(mealId, {restricted: true});
        if (this.isAlreadyClicked[key]) {
          return true;
        }
      }
      return false;
    },
    overrideForMeal(mealId) {
      // Toggle override state for this meal (allows re-enabling disabled checkboxes)
      this.$set(this.overrideMeals, mealId, !this.overrideMeals[mealId]);
    },
  },
  props: {
    basicView: {
      type: Boolean,
      default: false,
      required: false
    },
    isAdmin: {
      type: Boolean,
      default: false,
      required: false
    },
  }
}

</script>


<style>
.label-btn {
  width: 80px;
  /*max-width: 60px;*/
  /*overflow: clip;*/
  text-overflow: ellipsis;
}

.v-input--checkbox.v-input--is-disabled .v-label {
  text-decoration: line-through;
}

.v-input--checkbox.v-input--is-disabled {
  opacity: 0.4;
}
</style>